import React from 'react';
import { AssessmentProvider, useAssessment } from './context/AssessmentContext';
import { WelcomeScreen } from './components/WelcomeScreen';
import { QuizInterface } from './components/QuizInterface';
import { EmailRegistration } from './components/EmailRegistration';
import { ResultsDisplay } from './components/ResultsDisplay';
import { HistoryView } from './components/HistoryView';
import { ErrorBoundary } from './components/ErrorBoundary';

function AppContent() {
  const { state } = useAssessment();
  
  // Loading overlay
  if (state.isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-neutral-50 to-neutral-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-neutral-800 mx-auto mb-4"></div>
          <p className="text-neutral-600">Processing your assessment...</p>
        </div>
      </div>
    );
  }
  
  // Error state
  if (state.error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-neutral-50 to-neutral-100 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6">
            <svg className="w-12 h-12 text-red-500 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
            <h2 className="text-lg font-semibold text-red-800 mb-2">Something went wrong</h2>
            <p className="text-red-600 mb-4">{state.error}</p>
            <button 
              onClick={() => window.location.reload()}
              className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  // Render current screen
  switch (state.currentScreen) {
    case 'welcome':
      return <WelcomeScreen />;
    case 'quiz':
      return <QuizInterface />;
    case 'email-registration':
      return <EmailRegistration />;
    case 'results':
      return <ResultsDisplay />;
    case 'education':
      return (
        <div className="min-h-screen bg-gradient-to-br from-neutral-50 to-neutral-100 flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-neutral-800 mb-4">Education Coming Soon!</h1>
            <p className="text-neutral-600">We're still building the educational content component.</p>
          </div>
        </div>
      );
    case 'history':
      return <HistoryView />;
    default:
      return <WelcomeScreen />;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <AssessmentProvider>
        <AppContent />
      </AssessmentProvider>
    </ErrorBoundary>
  );
}

export default App;